// Lib
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// Actions
import { HideToast, ShowToast } from '@actions/toast';

// Types
import { RootState } from '@app-types/index';
import { ToastItem } from '@reducers/toast';

export interface UseToastReturn {
  toasts: ToastItem[];
  showToast: (title: string, message: string) => void;
  hideToast: (id: number) => void;
}

const useToast = (): UseToastReturn => {
  const dispatch = useDispatch();
  const { toasts } = useSelector((state: RootState) => state.Toast);

  const showToast = useCallback(
    (title: string, message: string): void => {
      dispatch(ShowToast({ title, message }));
    },
    [dispatch],
  );

  const hideToast = useCallback(
    (id: number): void => {
      dispatch(HideToast({ id }));
    },
    [dispatch],
  );

  return {
    toasts,
    showToast,
    hideToast,
  };
};

export default useToast;
